export async function getUploadParams(applicationId, group, file) {
    const url = '/api/application-files/params';

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            application: applicationId,
            group,
            filename: file.name,
            type: file.type,
            size: file.size,
        }),
    });

    let responseData = null;
    try {
        responseData = await response.json();
    } catch (_err) {
        throw new Error('Failed to get S3 upload parameters.');
    }

    if (!response.ok || !responseData) {
        if (responseData) {
            throw new Error(responseData.message);
        } else {
            throw new Error('Failed to get S3 upload parameters.');
        }
    }

    return responseData;
}

export async function uploadFile({ file, params, abortSignal, onProgress }) {
    const { attributes, inputs } = params;

    const formData = new FormData();
    Object.entries(inputs).forEach(([name, value]) => {
        formData.append(name, value);
    });
    formData.append('file', file);

    const xhr = new XMLHttpRequest();

    const handleAbort = () => {
        xhr.abort();
    };

    abortSignal?.addEventListener('abort', handleAbort);

    return new Promise((resolve, reject) => {
        xhr.responseType = 'blob';

        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4 || abortSignal.aborted) {
                return;
            }

            abortSignal?.removeEventListener('abort', handleAbort);

            if (xhr.status < 200 || xhr.status >= 300) {
                const err = new Error(xhr.response.statusText);
                err.xhr = xhr;

                reject(err);

                return;
            }

            const response = new Response(null, {
                url: xhr.responseURL,
                status: xhr.status,
                statusText: xhr.statusText,
            });

            resolve(response);
        };

        xhr.addEventListener('error', () => {
            reject(new TypeError('Failed to fetch'));
        });

        xhr.upload.addEventListener('progress', (event) => {
            onProgress?.(event.loaded / event.total);
        });

        xhr.open(attributes.method, attributes.action, true);

        xhr.send(formData);
    });
}

export async function updateFile(key, newProps) {
    const url = `/api/application-files/update`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({ key, ...newProps }),
    });

    if (!response.ok) {
        throw new Error(response.status);
    }
}

export async function deleteFile(key) {
    const url = `/api/application-files/delete`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({ key }),
    });

    if (!response.ok) {
        throw new Error(response.status);
    }
}

export async function getDownloadZipUrl(keys, filename) {
    const url = `/api/application-files/zip`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ keys, filename }),
    });

    if (!response.ok) {
        throw new Error(response.status);
    }

    return response.text();
}
